import { render, staticRenderFns } from "./zUnbind.vue?vue&type=template&id=1fd6d2c1"
import script from "./zUnbind.vue?vue&type=script&lang=js"
export * from "./zUnbind.vue?vue&type=script&lang=js"
import style0 from "./zUnbind.vue?vue&type=style&index=0&id=1fd6d2c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports